import { withCriteriaProvider } from './makeCriteriaProvider';
import useSearchableClientsWithHasMore, {
  useSearchableClientsForFilteringResourceUsers
} from './useSearchableClients';

export const makeCriteriaProvider = (tag, context) =>
  withCriteriaProvider(tag, context, useSearchableClientsWithHasMore);

export const makeEnhancedPMCriteriaProvider = (tag, context) =>
  withCriteriaProvider(
    tag,
    context,
    useSearchableClientsForFilteringResourceUsers
  );

export { withCriteriaProvider } from './makeCriteriaProvider';
